import { render, staticRenderFns } from "./RewardRow.vue?vue&type=template&id=b7beddce"
import script from "./RewardRow.vue?vue&type=script&lang=js"
export * from "./RewardRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports